import {Attachment, OptionValue} from "../SharedTypes";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {Checkbox, FormControlLabel, FormLabel, TextField} from "@material-ui/core";
import {Editor} from "@tinymce/tinymce-react";
import {WPMedia} from "./WPMedia";
import Button from "@material-ui/core/Button";
import React from "react";
import NumberFormat from "react-number-format";
import {makeStyles} from "@material-ui/core/styles";
import {inputStyles} from "../shared";

const useStyles = makeStyles({
    input: inputStyles,
});

export default function OptionValueEditor({value, onChange, onSave, onBack}: {
    value: OptionValue, onChange: (newOptionValue: OptionValue) => void
    onSave: () => any, onBack: () => any,
}) {
    const classes = useStyles();

    return <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom>Edit Option Value {value.name}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField id="name" label="Name" value={value.name} className={classes.input}
                               onChange={e => onChange({...value, name: e.target.value})}/>
                </Grid>
                <Grid item xs={12}>
                    <NumberFormat id="amount" label="Amount" value={value.pricing?.amount || ''} thousandSeparator
                                  prefix="$"
                                  customInput={TextField} decimalScale={2} className={classes.input}
                                  onValueChange={e => onChange({
                                      ...value,
                                      pricing: {...value.pricing, amount: e.value}
                                  })}/>
                </Grid>
                <Grid item xs={12}>
                    <NumberFormat id="maxQuantity" label="Max Quantity (Optional)"
                                  value={value.pricing?.maxQuantity || ''}
                                  thousandSeparator
                                  customInput={TextField} decimalScale={0} className={classes.input}
                                  onValueChange={e => onChange({
                                      ...value, pricing: {
                                          ...value.pricing as any, maxQuantity: e.value ? parseInt(e.value) : undefined
                                      }
                                  })}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField id="unitName" label="Unit Name" value={value.pricing?.unitName} className={classes.input}
                               onChange={e => onChange({
                                   ...value, pricing: {
                                       ...value.pricing as any, unitName: e.target.value ? e.target.value : undefined
                                   }
                               })}/>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={value.showCommentBox} onChange={e => onChange({
                            ...value, showCommentBox: e.target.checked
                        })} name="showCommentBox"/>}
                        label="Show Comment Box"
                    />
                </Grid>
                {value.showCommentBox ? <Grid item xs={12}>
                    <TextField id="commentBoxLabel" label="Comment Box Label" value={value.commentBoxLabel}
                               className={classes.input}
                               onChange={e => onChange({...value, commentBoxLabel: e.target.value})}/>
                </Grid> : null}
                {value.showCommentBox ? <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={value.autoFillColors} onChange={e => onChange({
                            ...value, autoFillColors: e.target.checked
                        })} name="autoFillColors"/>}
                        label="Autofill with Sherman-Williams Colors"
                    />
                </Grid> : null}
                <Grid item xs={12}>
                    <div style={{margin: '1rem', marginLeft: 0}}>
                        <FormLabel style={{display: 'block', marginBottom: '.5rem'}}>Description</FormLabel>
                        <Editor
                            tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                            value={value.description}
                            onEditorChange={description => onChange({...value, description})}
                            init={{
                                height: 260,
                                menubar: false,
                                plugins: [
                                    // 'advlist autolink lists link image charmap print preview anchor',
                                    // 'searchreplace visualblocks code fullscreen',
                                    // 'insertdatetime media table paste code help wordcount'
                                ],
                                toolbar: 'undo redo | formatselect | ' +
                                    'bold italic backcolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
            <WPMedia attachment={value.photo} label="Feature Image"
                     onChange={photo => onChange({...value, photo: photo as Attachment})}/>
        </Grid>

        <Grid item xs={12}>
            <div style={{marginTop: '2rem'}}>
                <Button color="primary" onClick={onBack}>
                    Back
                </Button>
                <Button variant="contained" color="primary"
                        onClick={onSave}>
                    Save
                </Button>
            </div>
        </Grid>
    </Grid>;
}